import React from 'react';
import { useCharitableGivingContext } from '../../context/useCharitableGivingContext';
import { ReviewItem } from '../Review/components/ReviewItem';

export const DonationYearReview = () => {
  const {
    workflow: {
      data: { donationStartYear, donationEndYear },
    },
  } = useCharitableGivingContext();

  return (
    <>
      <ReviewItem
        label={donationEndYear ? 'Donation Start Year' : 'Donation Year'}
        value={donationStartYear || '—'}
      />

      {!!donationEndYear && <ReviewItem label="Donation End Year" value={donationEndYear} />}
    </>
  );
};
